__turbopack_context__.v({
  "active": "button-module-scss-module__4QgQTW__active",
  "button": "button-module-scss-module__4QgQTW__button",
  "clear": "button-module-scss-module__4QgQTW__clear",
  "fullWidth": "button-module-scss-module__4QgQTW__fullWidth",
  "secondary": "button-module-scss-module__4QgQTW__secondary",
});
